import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=3a43621a&scoped=true&"
import script from "./organizations.vue?vue&type=script&lang=js&"
export * from "./organizations.vue?vue&type=script&lang=js&"
import style0 from "./organizations.vue?vue&type=style&index=0&id=3a43621a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43621a",
  null
  
)

export default component.exports